var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 388 355",
    width: 388,
    height: 355,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 316-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #8e99c3 } \n\t\t.s1 { fill: none;stroke: #8e99c3;stroke-width: 5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m297.5 52.3c5.5 0 9.9 4.6 9.9 10.3v11.9h11.6c5.5 0 10 4.6 10 10.3v6.8c0 5.7-4.5 10.2-10 10.2h-11.6v13.7c0 5.7-4.4 10.3-9.9 10.3h-6.7c-5.5 0-9.9-4.6-9.9-10.3v-13.7h-13.3c-5.5 0-10-4.5-10-10.2v-6.8c0-5.7 4.5-10.3 10-10.3h13.3v-11.9c0-5.7 4.4-10.3 9.9-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m101.9 52.3c5.5 0 10 4.6 10 10.3v11.9h11.6c5.5 0 10 4.6 10 10.3v6.8c0 5.7-4.5 10.2-10 10.2h-11.6v13.7c0 5.7-4.5 10.3-10 10.3h-6.6c-5.5 0-10-4.6-10-10.3v-13.7h-13.2c-5.5 0-10-4.5-10-10.2v-6.8c0-5.7 4.5-10.3 10-10.3h13.2v-11.9c0-5.7 4.5-10.3 10-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.9 230.2c5.5 0 10 4.6 10 10.3v11.9h11.6c5.5 0 10 4.6 10 10.3v6.8c0 5.7-4.5 10.3-10 10.3h-11.6v13.6c0 5.7-4.5 10.3-10 10.3h-6.6c-5.5 0-10-4.6-10-10.3v-13.6h-13.2c-5.5 0-10-4.6-10-10.3v-6.8c0-5.7 4.5-10.3 10-10.3h13.2v-11.9c0-5.7 4.5-10.3 10-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m297.5 230.2c5.5 0 9.9 4.6 9.9 10.3v11.9h11.6c5.5 0 10 4.6 10 10.3v6.8c0 5.7-4.5 10.3-10 10.3h-11.6v13.6c0 5.7-4.4 10.3-9.9 10.3h-6.7c-5.5 0-9.9-4.6-9.9-10.3v-13.6h-13.3c-5.5 0-10-4.6-10-10.3v-6.8c0-5.7 4.5-10.3 10-10.3h13.3v-11.9c0-5.7 4.4-10.3 9.9-10.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9d41bce9a4cd8b487eecd390347d32d6.svg";
export { ForwardRef as ReactComponent };